import React from 'react';

/**
 * NestWise brand lockup — logo + wordmark or icon-only.
 * Kept as a single source of truth so the brand can evolve without
 * hunting for `<Leaf>` instances across the app.
 */
export const BrandMark = ({ variant = 'full', size = 32, className = '', ...rest }) => {
  const srcMap = {
    full: '/nestwise-logo.png',
    icon: '/nestwise-icon.png',
    white: '/nestwise-logo-white.png',
  };
  const src = srcMap[variant] || srcMap.full;
  // Height-based sizing; width auto-scales to preserve aspect ratio.
  const style = { height: `${size}px`, width: 'auto' };
  return (
    <img
      src={src}
      alt="NestWise"
      style={style}
      className={`select-none ${className}`}
      draggable={false}
      {...rest}
    />
  );
};

export default BrandMark;
